"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconButton = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Box = require("../Box");

var _baseStyle = require("../shared/baseStyle");

var _styleHelpers = require("../styleHelpers");

var _useCustomStyles = require("../utils/useCustomStyles");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var IconButton = _styledComponents.default.button.attrs(function (props) {
  return {
    size: props.size || 'medium',
    color: props.color || 'plain',
    active: props.active || false
  };
}).withConfig({
  displayName: "IconButton",
  componentId: "sc-1vmpeji-0"
})(["", " width:", ";height:", ";background-color:", ";color:", ";border:0;padding:0;outline:0;box-sizing:border-box;transition:", ";border-radius:", ";display:flex;justify-content:center;align-items:center;flex-shrink:0;& > *{width:", ";height:", ";transition:", ";transform:scale( ", " );}&:not(:disabled){cursor:pointer;}&:disabled{opacity:", ";cursor:normal;}", " ", " ", ""], _baseStyle.baseStyle, (0, _styleHelpers.getComponentStyle)('iconButton.size.{size}'), (0, _styleHelpers.getComponentStyle)('iconButton.size.{size}'), (0, _styleHelpers.getComponentStyle)('iconButton.{color}.backgroundColor'), (0, _styleHelpers.getComponentStyle)('iconButton.{color}.color'), (0, _styleHelpers.getComponentStyle)('iconButton.transition', _styleHelpers.transitionTransformer), (0, _styleHelpers.getComponentStyle)('iconButton.borderRadius'), (0, _styleHelpers.getComponentStyle)('iconButton.icon.size.{size}'), (0, _styleHelpers.getComponentStyle)('iconButton.icon.size.{size}'), (0, _styleHelpers.getComponentStyle)('iconButton.icon.transition', _styleHelpers.transitionTransformer), function (props) {
  return props.active ? props.theme.componentStyles.iconButton.icon.active.scale : props.theme.componentStyles.iconButton.icon.scale;
}, (0, _styleHelpers.getComponentStyle)('iconButton.disabled.opacity'), (0, _useCustomStyles.getCustomStyles)('iconButton.styles', 'root'), function (props) {
  return props.active ? (0, _styledComponents.css)(["background-color:", ";color:", ";", ""], (0, _styleHelpers.getComponentStyle)('iconButton.{color}.active.backgroundColor'), (0, _styleHelpers.getComponentStyle)('iconButton.{color}.active.color'), (0, _useCustomStyles.getCustomStyles)('iconButton.styles', 'active')) : (0, _styledComponents.css)(["&:hover:not(:disabled){background-color:", ";color:", ";", "}&:focus:not(:disabled){background-color:", ";color:", ";", "}"], (0, _styleHelpers.getComponentStyle)('iconButton.{color}.hover.backgroundColor'), (0, _styleHelpers.getComponentStyle)('iconButton.{color}.hover.color'), (0, _useCustomStyles.getCustomStyles)('iconButton.styles', 'hover'), (0, _styleHelpers.getComponentStyle)('iconButton.{color}.focus.backgroundColor'), (0, _styleHelpers.getComponentStyle)('iconButton.{color}.focus.color'), (0, _useCustomStyles.getCustomStyles)('iconButton.styles', 'focus'));
}, function (_ref) {
  var size = _ref.size,
      props = _objectWithoutProperties(_ref, ["size"]);

  return (0, _Box.layoutInterpolationFn)(props);
});

exports.IconButton = IconButton;